import { render, staticRenderFns } from "./WiseFooter.vue?vue&type=template&id=b43ebf5e&scoped=true"
import script from "./WiseFooter.vue?vue&type=script&lang=js"
export * from "./WiseFooter.vue?vue&type=script&lang=js"
import style0 from "./WiseFooter.vue?vue&type=style&index=0&id=b43ebf5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43ebf5e",
  null
  
)

export default component.exports